<template>
	<div>
		<div class="text-center list-title">
			Реестр актов
		</div>
		<div class="year-wrap">
			<label>
				Год размещения
				<select v-model="selected_year">
					<option v-for="year in years" :key="year">
						{{ year }}
					</option>
				</select>
			</label>
		</div>
		<div class="l-header-wrapper">
			<table class='header'>
				<thead>
					<tr>
						<th class='center l-td'>№ акта</th>
						<th class='center l-td'>Дата размещения</th>
						<th class='center l-td'>Ссылка</th>
						<th class='center l-td'>ФО</th>
						<th class='center l-td'>Субъект РФ</th>
						<th class='center l-td'>Лесничество</th>
						<th class='center l-td'>Уч. лесничество</th>
						<th class='center l-td'>Подлесничество</th>
						<th class='center l-td'>Квартал</th>
						<th class='center l-td'>Выдел</th>
						<th class='center l-td'>Л.п. выдел</th>
						<th class='center l-td'>Дата заключения</th>
						<th class='center l-td'>Номер заключения</th>
						<th class="l-scroll"></th>
					</tr>
					<tr>
						<th class='l-td'><filter-table field='num' :filter='filter' :year='selected_year'/></th>
						<th class='l-td'><filter-table-date-range field='act_placement_date' :filter='filter'/></th>
						<th class='l-td'><filter-table field='url' :filter='filter' :year='selected_year'/></th>
						<th class='l-td'><filter-table field='fo' :filter='filter' :year='selected_year'/></th>
						<th class='l-td'><filter-table field='region' :filter='filter' :wideWindow='true' :year='selected_year'/></th>
						<th class='l-td'><filter-table field='forestry' :filter='filter' :year='selected_year'/></th>
						<!-- <th class='center'>flag_lf</th>
						<th class='center'>count_lf</th> -->
						<th class='l-td'><filter-table field='localforestry' :filter='filter' :year='selected_year'/></th>
						<!-- <th class='center'>flag_sf</th>
						<th class='center'>count_sf</th> -->
						<th class='l-td'><filter-table field='subforestry' :filter='filter' :year='selected_year'/></th>
						<th class='l-td'><filter-table field='area' :filter='filter' :year='selected_year'/></th>
						<th class='l-td'><filter-table field='section' :filter='filter' :year='selected_year'/></th>
						<th class='l-td'><filter-table field='section_lp' :filter='filter' :year='selected_year'/></th>
						<!-- <th class='l-td'><filter-table field='conclusion_date' :filter='filter'/></th> -->
						<th class='l-td'><filter-table-date-range field='conclusion_date' :rightAlign='true' :filter='filter' :year='selected_year'/></th>
						<!-- <th class='l-td'><filter-table field='conclusion_num' :filter='filter'></filter-table></th> -->
						<th class='l-td'><filter-table field='conclusion_num' :filter='filter' :rightAlign='true' :year='selected_year'/></th>
						<th class="l-scroll" @click='clearFilters'><span class="glyphicon glyphicon-remove pointer" title="Сбросить фильтры"></span></th>
					</tr>
				</thead>
			</table>
		</div>
		<div class="l-body-wrapper" :class='{"no_scroll": loading}'>
			<table class='body'>
				<tbody>
					<tr v-for='(line,i) in lines' @click='select_line(i)' :class='{ selected: line.selected }' :key='line.act_id'>
					<td v-if='line.flag' :rowspan='line.count' class='td-num l-td'>{{line.num}}</td>
					<td v-if='line.flag' :rowspan='line.count' class='l-td'>{{line.act_placement_date}}</td>
					<td v-if='line.flag' :rowspan='line.count' class='td-url large-td'><a :href="line.url">{{line.url}}</a></td>
					<td v-if='line.flag' :rowspan='line.count' class='l-td'>{{line.fo}}</td>					
					<td v-if='line.flag' :rowspan='line.count' class='l-td'>{{line.region}}</td>					
					<td v-if='line.flag' :rowspan='line.count' class='l-td'>{{line.forestry}}</td>

					<!-- <td>{{line.id}}</td> -->
					<!-- <td>{{line.flag}}</td>
					<td>{{line.count}}</td>
					<td>{{line.num}}</td>
					<td><a :href="line.url">{{line.url}}</a></td>
					<td>{{line.fo}}</td>					
					<td>{{line.region}}</td>					
					<td>{{line.forestry}}</td>
					
					<td>{{line.flag_lf}}</td>
					<td>{{line.count_lf}}</td> -->
					<td v-if='line.flag_lf' :rowspan='line.count_lf' class='l-td'>{{line.localforestry}}</td>
					<!-- <td>{{line.localforestry}}</td>
					
					<td>{{line.flag_sf}}</td>
					<td>{{line.count_sf}}</td> -->

					<td v-if='line.flag_sf' :rowspan='line.count_sf' class='l-td'>{{line.subforestry}}</td>
					<!-- <td>{{line.subforestry}}</td> -->
					<td class='l-td'>{{line.area}}</td>
					<td class='l-td'>{{line.section}}</td>
					<td class='l-td'>{{line.section_lp}}</td>
					<td class='l-td'>{{line.conclusion_date}}</td>
					<td class='l-td'>{{line.conclusion_num}}</td>
					<td width='17' v-if='loading'></td>
				</tr>
			</tbody>
		</table>
		<div class='loading-wrap' v-if='loading'>
			<i class='fa fa-spinner fa-spin' style='font-size:48px;'></i>
		</div>
	</div>
<div class="text-center">
	<ul class="pagination" v-if='pages'>
		<li :class='{ active: page.active }' v-for='page in pages'>
			<a v-if='isNumeric(page.num)' href='#' @click='select_page' :data-value='page.num'>{{page.num}}</a>
			<span v-else href='#' class="disabled_page">{{page.num}}</span>
		</li>
	</ul>
</div>
</div>
</template>

<script>

	import {DB} from './../constants'
	import {ROWS_ON_PAGE} from './../constants'
	// const TABLE = 'get_journal.php'
	const TABLE = 'get_journal.php'
	// const TABLE = 'get_journal_new.php'
	const FILTER_TABLE = 'get_journal_filter.php'
	const GET_JOURNAL_YEARS = "get_journal_years.php"
	const COUNT_OF_FILTERS = 13
	const PADDING = 3

	import { EventBus } from '../lib/EventBus'

	import filterTable from './Filter'
	import filterTableDateRange from './FilterDateRange'
	import moment from 'moment'

	import '../lib/css/fontawesome-all.min.css'

	export default {
	name: 'list',
	data () {
		return {
			lines: [],
			selected: 0,
			pages: [],
			active: 1,
			pages_count: 1,
			cf_count: 0,
			loading: false,
			years: [],
			selected_year: null,

			filter: {
				num: [],
				act_placement_date: [],
				url: [],
				fo: [],
				region: [],
				forestry: [],
				localforestry: [],
				subforestry: [],
				area: [],
				section: [],
				section_lp: [],
				conclusion_date: [],
				conclusion_num: [],
				page_num: null
			}
		}
	},
	components: {
		filterTable, filterTableDateRange
	},
	watch: {
		selected_year(newVal, oldVal) {
			if(oldVal === null) {
				return;
			}
			this.filter_lines()
		}
	},
	methods: {
		isNumeric (x) {
			return !Number.isNaN(+x)
		},
		select_line (i) {
			if (!this.lines[i].flag) {
				let k = i
				while (!this.lines[k].flag) {
					k--
				}

				i = k
			}

			this.selected = i

			for (let j = 0; j < this.lines.length; j++) {
				if (this.lines[j].flag) {
					this.lines[j].selected = (i === j)
				}
				else {
					let k = j
					while (!this.lines[k].flag) {
						k--
					}
					for (let l = 0; l < this.lines[k].count; l++) {
						this.lines[j].selected = (i === k)
					}
				}
			}

			EventBus.$emit('act_id', this.lines[i].id)

			// document.getElementById(i).checked = true
			//EventBus.$emit('can_edit', {act: this.lines[i].can_edit_act, conclusion: this.lines[i].can_edit_conclusion, warrant: this.lines[i].can_edit_warrant})
		},
		fetch_lines (start) {
			document.querySelector('.l-body-wrapper').scrollTop = 0
			this.loading = true
			let temp_lines = []
			let temp_pages = []

			let where = '('
			for (let f in this.filter) {
				if(f == 'conclusion_date' || f == 'act_placement_date') {
					if(this.filter[f].length == 2) {
						const from = this.filter[f][0]
						const to = this.filter[f][1]
						where += `${f} BETWEEN '${from}' AND '${to}'  or `
					}
				} else {
					for (let i = 0; i < this.filter[f].length; i++) {
						if (f !== this.field) 
							where += this.filter[f][i] !== '' ? `${f}='${this.filter[f][i]}' or ` : `${f} is null or `							
					}
				}
				
				if (f !== this.field) {
					where = this.filter[f].length !== 0 ? where.slice(0,-4) : where
					where += this.filter[f].length !== 0 ? ') and (' : ''
				}
			}
			where = where.slice(0,-6)
			if(where)
				where = '&filter=' + where

			fetch(DB + FILTER_TABLE + `?start=${start}&rows=${ROWS_ON_PAGE}${where}`, {
				// fetch(DB + TABLE, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res =>{
					let prev_id = -1
					let prev_localforestry_id = -1
					let prev_subforestry_id = -1
					for (let i = 0; i < res.length - 1; i++) {
						let act = {}

						let start_fo = i
						while (i > 0 && res[start_fo - 1].act_id === res[i].act_id && start_fo > 1) {
							start_fo--
						}

						let curr = start_fo
						while (curr < res.length && res[curr].act_id === res[start_fo].act_id ) {
							curr++
						}
						act.count = curr - start_fo

						if (res[i].act_id === prev_id) {
							act.flag = false
						}
						else {
							act.flag = true
						}
						//////////////////

						let start_lf = i
						while (i > 0 && res[start_lf - 1].localforestry_id === res[i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[i].act_id) {
							start_lf--
						}

						let curr_lf = start_lf
						while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[i].localforestry_id) {
							curr_lf++
						}
						act.count_lf = curr_lf - start_lf

						if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
							act.flag_lf = false
						}
						else {
							act.flag_lf = true
						}

						////////////////////////
						let start_sf = i
						while (i > 0 && res[start_sf - 1].localforestry_id === res[i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[i].act_id) {
							start_sf--
						}

						let curr_sf = start_sf
						while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[i].localforestry_id) {
							curr_sf++
						}
						act.count_sf = curr_sf - start_sf

						if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
							act.flag_sf = false
						}
						else {
							act.flag_sf = true
						}
						////////////////////////
						

						prev_id = res[i].act_id
						prev_localforestry_id = res[i].localforestry_id
						prev_subforestry_id = res[i].subforestry_id

						act.id = res[i].act_id
						act.act_placement_date = res[i].act_placement_date
						act.num = res[i].num
						act.url = res[i].url
						act.fo = res[i].fo
						act.region = res[i].region
						act.forestry = res[i].forestry
						act.localforestry = res[i].localforestry
						act.subforestry = res[i].subforestry
						act.area = res[i].area
						act.section = res[i].section
						act.section_lp = res[i].section_lp
						act.conclusion_date = res[i].conclusion_date ? moment(res[i].conclusion_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
						act.conclusion_num = res[i].conclusion_num;
						act.selected = false

						temp_lines.push(act)
					}


					this.lines = temp_lines

					temp_lines = []

					// this.pages = temp_pages

					this.lines[0].selected = true

					if (!this.lines[1].flag) {
						let k = 1
						while (!this.lines[k].flag) {
							this.lines[k].selected = true
							k++
						}
					}

					EventBus.$emit('act_id', this.lines[0].id)
					this.loading = false
				})
				.catch(err => console.log(err))
			},
			select_page (e) {
				let value = e
				if(!this.isNumeric(value)) 
					value = +e.target.getAttribute('data-value')

				this.fetch_lines((value - 1) * ROWS_ON_PAGE + 1)
				this.active = value
				this.page_num = value
				let temp_pages = []

				if(this.active - 1 > PADDING) {
					temp_pages.push({active: false, num: 1})

					if(this.active - 2 > PADDING)
						temp_pages.push({active: false, num: '...'})					
				}

				for (let i = this.active - PADDING - 1; i < this.active + PADDING; i++)
					if(i >= 0 && i < this.pages_count)
						temp_pages.push({active: false, num: i + 1})

				if(this.active < this.pages_count - PADDING)
				{
					if(this.active + 1 < this.pages_count - PADDING)
						temp_pages.push({active: false, num: '...'})

					temp_pages.push({active: false, num: this.pages_count})
				}

				this.pages = temp_pages

				this.pages.forEach(p => {
					p.active = (p.num == this.active)
				})

				//this.pages[value - 1].active = true
			},
			clearFilters () {
				this.cf_count = 0
				this.$parent.selected_filters = {}
				EventBus.$emit('clearFilters')
			},
			async filter_lines (save_page = false) {
				if(!this.years || !this.years.length || !this.selected_year) {
					await this.getJournalYears()
				}
				document.querySelector('.l-body-wrapper').scrollTop = 0
				this.loading = true
				let temp_lines = []
				let temp_pages = []

				let where = '('
				for (let f in this.filter) {
					if(f == 'conclusion_date' || f == 'act_placement_date') {
						if(this.filter[f].length == 2) {
							const from = this.filter[f][0]
							const to = this.filter[f][1]
							where += `${f} BETWEEN '${from}' AND '${to}'  or `
						}
					} else {
						for (let i = 0; i < this.filter[f].length; i++) {
							if (f !== this.field) 
								where += this.filter[f][i] !== '' ? `${f}='${this.filter[f][i]}' or ` : `${f} is null or `							
						}
					}
					
					if (f !== this.field) {
						where = this.filter[f].length !== 0 ? where.slice(0,-4) : where
						where += this.filter[f].length !== 0 ? ') and (' : ''
					}
				}
				where = where.slice(0,-6)
				if(where && where.length) {
					where += ' and '
				}
				where += `(act_placement_date BETWEEN '${this.selected_year}-01-01' AND '${this.selected_year}-12-31')`

				let start = 1

				//console.warn('save_page 1', save_page, this.active, this.page_num)
				if(save_page) {
					start = (this.page_num - 1) * ROWS_ON_PAGE + 1
					//this.active = this.page_num
				} else if (this.$route.params.id || this.$parent.act_id) {
					start = (this.page_num - 1) * ROWS_ON_PAGE + 1
					this.active = this.page_num
				}

				//console.warn('save_page 2', save_page, this.active, this.page_num)

				let t = TABLE + `?start=${start}&rows=${ROWS_ON_PAGE}`
				if (where) {
					t = FILTER_TABLE + `?start=${start}&rows=${ROWS_ON_PAGE}&filter=${where}`
				}

				fetch(DB + t, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res =>{
					let prev_id = -1
					let prev_localforestry_id = -1
					let prev_subforestry_id = -1

					let length = (!!where) ? res.length : res.length - 1

					for (let i = 0; i < length; i++) {
						let act = {}

						let start_fo = i
						while (i > 0 && res[start_fo - 1].act_id === res[i].act_id && start_fo > 1) {
							start_fo--
						}

						let curr = start_fo
						while (curr < res.length && res[curr].act_id === res[start_fo].act_id ) {
							curr++
						}
						act.count = curr - start_fo

						if (res[i].act_id === prev_id) {
							act.flag = false
						}
						else {
							act.flag = true
						}
						//////////////////

						let start_lf = i
						while (i > 0 && res[start_lf - 1].localforestry_id === res[i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[i].act_id) {
							start_lf--
						}

						let curr_lf = start_lf
						while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[i].localforestry_id) {
							curr_lf++
						}
						act.count_lf = curr_lf - start_lf

						if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
							act.flag_lf = false
						}
						else {
							act.flag_lf = true
						}

						////////////////////////
						let start_sf = i
						while (i > 0 && res[start_sf - 1].localforestry_id === res[i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[i].act_id) {
							start_sf--
						}

						let curr_sf = start_sf
						while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[i].localforestry_id) {
							curr_sf++
						}
						act.count_sf = curr_sf - start_sf

						if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
							act.flag_sf = false
						}
						else {
							act.flag_sf = true
						}
						////////////////////////
						

						prev_id = res[i].act_id
						prev_localforestry_id = res[i].localforestry_id
						prev_subforestry_id = res[i].subforestry_id

						act.id = res[i].act_id
						act.num = res[i].num
						act.act_placement_date = res[i].act_placement_date ? moment(res[i].act_placement_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : ''
						act.url = res[i].url
						act.fo = res[i].fo
						act.region = res[i].region
						act.forestry = res[i].forestry
						act.localforestry = res[i].localforestry
						act.subforestry = res[i].subforestry
						act.area = res[i].area
						act.section = res[i].section
						act.section_lp = res[i].section_lp
						act.conclusion_date = res[i].conclusion_date ? moment(res[i].conclusion_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
						act.conclusion_num = res[i].conclusion_num;
						act.selected = false
						
						temp_lines.push(act)
					}

					//if (!where) {
						//let count = Math.round(res[res.length - 1].count / ROWS_ON_PAGE)
						this.pages_count = Math.round(res[res.length - 1].count / ROWS_ON_PAGE)
						temp_pages = []

						if(this.active > PADDING)
						{
							temp_pages.push({active: false, num: 1})
							temp_pages.push({active: false, num: '...'})
						}

						
						for (let i = this.active - PADDING; i < this.active + PADDING; i++) {
							if(i >= 0 && i < this.pages_count)
								temp_pages.push({active: false, num: i + 1})
						}

						if(this.active < this.pages_count - PADDING)
						{
							temp_pages.push({active: false, num: '...'})
							temp_pages.push({active: false, num: this.pages_count})
						}

						this.pages = temp_pages
						this.pages.forEach(p => {
							p.active = (p.num == this.active)
						})
					//}

					this.lines = temp_lines

					if(this.$route.params.id || this.$parent.act_id) {
						let act_id = this.$route.params.id || this.$parent.act_id
						let found = false
						for (let i = 0; i < this.lines.length; i++) {
							if (this.lines[i].id == act_id) {
								this.select_line(i)

								this.$nextTick(() => {
									const selected_row = document.querySelector("tr.selected")
									if(selected_row)
										selected_row.scrollIntoView(true)
								})
								
								found = true
								break
							}
						}
						if(!found)
							this.select_line(0)
					}
					else {
						this.select_line(0)
					}
					
					this.loading = false
				})
				.catch(err => console.log(err))
			},
			resizeList () {
				const dispay_height = document.documentElement.clientHeight - 234
				document.querySelector('.l-body-wrapper').style.maxHeight = `${dispay_height}px`
			},
			async getJournalYears() {
				await fetch(DB + GET_JOURNAL_YEARS, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(json => {
					if(json && json.length) {
						this.years = json.map(e => e.years)
						this.selected_year = this.years[0]
					}
				})
			}
		},
		created () {

		},
		mounted () {
			this.$parent.lastJournalURL = '/main'

			this.getJournalYears()

			EventBus.$on('filter_list', f => {
				console.warn('filter_list')
				this.filter[f.field] = f.value !== '' ? f.value : null

				this.active = 1
				if(f.cf) //clearFilters
				{
					this.cf_count++
					if(this.cf_count == COUNT_OF_FILTERS)
						this.filter_lines()
				}
				else
					this.filter_lines()
			})

			this.page_num = this.$parent.page_num ? this.$parent.page_num : 1
			this.active = this.page_num

			this.filter = this.$parent.filter				
			this.filter_lines()

			// const w = document.documentElement.clientWidth - 50
			// document.querySelector('.main_table_wrapper').style.width = `${w}px`

			////////////////////////////////////////////

			const dispay_width = document.documentElement.clientWidth
			// const dispay_height = document.documentElement.clientHeight - 146
			const dispay_height = document.documentElement.clientHeight - 234
			let scroll_width = 17

			const ua = navigator.userAgent

			if (ua.search('OPR/') > 0) {
				scroll_width = 15
			}

			const table_width = dispay_width - scroll_width
			const col_width = Math.floor(table_width / 11)
			// 
			const large_width = table_width - (col_width * 9)

			// console.log(col_width, large_width, table_width, col_width * 9 + large_width)


			document.querySelectorAll('.l-td').forEach(td => {
				td.width = col_width
			})
			document.querySelectorAll('.large-td').forEach(td => {
				td.width = large_width
			})
			document.querySelector('.l-header-wrapper').width = dispay_width
			document.querySelector('.l-body-wrapper').width = dispay_width
			document.querySelector('.l-body-wrapper').style.maxHeight = `${dispay_height}px`

		// console.log(dispay_height, dispay_width, col_width, table_width)
		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

			document.querySelector('.l-scroll').width = scroll_width

			window.addEventListener('resize', this.resizeList, true);

			EventBus.$on('delete_act', () => {
				this.filter_lines(true)
			})
		},
		beforeDestroy() {
			//this.lines = []
			EventBus.$off('filter_list')
			EventBus.$off('delete_act')
			//EventBus.$emit('save-filter', {f: this.filter})
			EventBus.$emit('save-page', this.active)
			window.removeEventListener('resize', this.resizeList, true)
		}
	}

</script>

<style>
	div.l-header-wrapper {
		border: 1px solid black;
		border-bottom: none;  
		/*width: 1634px;*/
	}

	div.l-body-wrapper {
		overflow-x: hidden;
		overflow-y: scroll;
		/*width: 1634px;*/
		/*max-height: 1200px;*/
		border: 1px solid black;
		border-top: none;
		position: relative;
	}

	.no_scroll {
		overflow: hidden !important;
	}

	table.header {
		border-bottom: 1px solid black;
		width: 100%;
	}

	td.l-td,  th.l-td {
		vertical-align: middle; 
		word-break: break-all; 
		font-size: 12px;
	}

	td.large-td,  th.large-td {
		/*width: 214px;*/
		vertical-align: middle;  
	}

	table.body {
		width: 100%;
		table-layout: fixed;
	}

	.main_table tr, td, .main_table tr, th {
		text-align: center !important;
		border: 1px solid;
		border-collapse: collapse;
	}

	.td-url {
		word-break: break-all;
	}

	.td-num {
		max-width: 170px;
	}

	.main_table tr {
		height: 21px;
	}


	/* .radio_input {
	margin: 5px !important;
	} */

	th.center {
		text-align: center !important;
	}

	.selected {
		background-color: skyblue;
	}

	.disabled_page {
		cursor: default;
	}
</style>

<style scoped>
	.pagination {
		margin: 20px 0 4px 0;
	}

	.loading-wrap {
		position: absolute;
	    left: 0;
	    right: 0;
	    z-index: 1000;
	    top: 0;
	    bottom: 0;
	    background: rgba(255,255,255,0.8);
	    display: flex;
    	align-items: center;
    	justify-content: center;
	} 
</style>


// WEBPACK FOOTER //
// List.vue?08f8936b